// This file is hand-maintained. Registration order matters — Trix and Flash
// load first, then the rest. If you add a new Stimulus controller, register
// it here. Do NOT run `bin/rails stimulus:manifest:update` — it would erase
// the load-order grouping and the inline notes about removed controllers.

import { application } from "./application"

// Critical controllers that should initialize early
import TrixEditorController from "./trix_editor_controller"
application.register("trix-editor", TrixEditorController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

// Regular controllers
import AmenityCategoryFormController from "./amenity_category_form_controller"
application.register("amenity-category-form", AmenityCategoryFormController)

import AmenityFormController from "./amenity_form_controller"
application.register("amenity-form", AmenityFormController)

import AnalyticsDashboardController from "./analytics_dashboard_controller"
application.register("analytics-dashboard", AnalyticsDashboardController)

import ArrivalsFilterController from "./arrivals_filter_controller"
application.register("arrivals-filter", ArrivalsFilterController)

import AutoRotateController from "./auto_rotate_controller"
application.register("auto-rotate", AutoRotateController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AvailabilityController from "./availability_controller"
application.register("availability", AvailabilityController)

// friday_checkout_controller removed - business logic moved to backend PricingRule model

import GroupBookingCartController from "./group_booking_cart_controller"
application.register("group-booking-cart", GroupBookingCartController)

import BannerController from "./banner_controller"
application.register("banner", BannerController)

import BedFieldController from "./bed_field_controller"
application.register("bed-field", BedFieldController)

import BulkSelectionController from "./bulk_selection_controller"
application.register("bulk-selection", BulkSelectionController)

import MinimumStayValidatorController from "./minimum_stay_validator_controller"
application.register("minimum-stay-validator", MinimumStayValidatorController)

import CampgroundMapController from "./campground_map_controller"
application.register("campground-map", CampgroundMapController)

import CampsiteController from "./campsite_controller"
application.register("campsite", CampsiteController)

import CampsiteFilterController from "./campsite_filter_controller"
application.register("campsite-filter", CampsiteFilterController)

import CampsitesController from "./campsites_controller"
application.register("campsites", CampsitesController)

import CampsiteTypeController from "./campsite_type_controller"
application.register("campsite-type", CampsiteTypeController)

import CategorySelectorController from "./category_selector_controller"
application.register("category-selector", CategorySelectorController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CartCheckoutController from "./cart_checkout_controller"
application.register("cart-checkout", CartCheckoutController)

import CartCountdownController from "./cart_countdown_controller"
application.register("cart-countdown", CartCountdownController)

import CompactSearchController from "./compact_search_controller"
application.register("compact-search", CompactSearchController)

import ConfirmSubmitController from "./confirm_submit_controller"
application.register("confirm-submit", ConfirmSubmitController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import CustomerFormController from "./customer_form_controller"
application.register("customer-form", CustomerFormController)

import CustomerModalController from "./customer_modal_controller"
application.register("customer-modal", CustomerModalController)

import CustomerSearchController from "./customer_search_controller"
application.register("customer-search", CustomerSearchController)

import CustomerReservationChangeController from "./customer_reservation_change_controller"
application.register("customer-reservation-change", CustomerReservationChangeController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DisableWithController from "./disable_with_controller"
application.register("disable-with", DisableWithController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import DynamicFieldsController from "./dynamic_fields_controller"
application.register("dynamic-fields", DynamicFieldsController)

import FileValidationController from "./file_validation_controller"
application.register("file-validation", FileValidationController)

import FlowbiteDatepickerController from "./flowbite_datepicker_controller"
application.register("flowbite-datepicker", FlowbiteDatepickerController)

// gallery_controller removed - unused, PhotoSwipe dropped (PF3B)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HwComboboxController from "./hw_combobox_controller"
application.register("hw-combobox", HwComboboxController)

import IconPreviewController from "./icon_preview_controller"
application.register("icon-preview", IconPreviewController)

import IconSelectorController from "./icon_selector_controller"
application.register("icon-selector", IconSelectorController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

// import MapController from "./map_controller"
// application.register("map", MapController)

import MasqueradeController from "./masquerade_controller"
application.register("masquerade", MasqueradeController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import MinimumStayController from "./minimum_stay_controller"
application.register("minimum_stay", MinimumStayController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModificationPricingController from "./modification_pricing_controller"
application.register("modification-pricing", ModificationPricingController)

import NavMenuController from "./nav_menu_controller"
application.register("nav-menu", NavMenuController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PaymentController from "./payment_controller"
application.register("payment", PaymentController)

import PaymentFormController from "./payment_form_controller"
application.register("payment-form", PaymentFormController)

import PaymentMethodController from "./payment_method_controller"
application.register("payment-method", PaymentMethodController)

import PaymentStatusController from "./payment_status_controller"
application.register("payment-status", PaymentStatusController)

import PerPageController from "./per_page_controller"
application.register("per-page", PerPageController)

import PricesController from "./prices_controller"
application.register("prices", PricesController)

import PricingRulesController from "./pricing_rules_controller"
application.register("pricing-rules", PricingRulesController)

import QuickCustomerController from "./quick_customer_controller"
application.register("quick-customer", QuickCustomerController)

import RentalAvailabilityController from "./rental_availability_controller"
application.register("rental-availability", RentalAvailabilityController)

import RentalBedsController from "./rental_beds_controller"
application.register("rental-beds", RentalBedsController)

import RentalBookingController from "./rental_booking_controller"
application.register("rental-booking", RentalBookingController)

// rental_calendar_controller removed - unused, FullCalendar dropped (PF3B)

import RentalController from "./rental_controller"
application.register("rental", RentalController)

import RentalFilterController from "./rental_filter_controller"
application.register("rental-filter", RentalFilterController)

import RentalFormController from "./rental_form_controller"
application.register("rental-form", RentalFormController)

import RentalImagesController from "./rental_images_controller"
application.register("rental-images", RentalImagesController)

import RentalPreviewController from "./rental_preview_controller"
application.register("rental-preview", RentalPreviewController)

import RentalSearchController from "./rental_search_controller"
application.register("rental-search", RentalSearchController)

import ReservationAuthController from "./reservation_auth_controller"
application.register("reservation-auth", ReservationAuthController)

import ReservationCalendarController from "./reservation_calendar_controller"
application.register("reservation-calendar", ReservationCalendarController)

import ReservationChangeController from "./reservation_change_controller"
application.register("reservation-change", ReservationChangeController)

import ReservationController from "./reservation_controller"
application.register("reservation", ReservationController)

import ReservationEditController from "./reservation_edit_controller"
application.register("reservation-edit", ReservationEditController)

import ReservationStatusController from "./reservation_status_controller"
application.register("reservation-status", ReservationStatusController)

import ReservationWizardController from "./reservation_wizard_controller"
application.register("reservation-wizard", ReservationWizardController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import ScrollableTableController from "./scrollable_table_controller"
application.register("scrollable-table", ScrollableTableController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import SearchShortcutController from "./search_shortcut_controller"
application.register("search-shortcut", SearchShortcutController)

import SessionFlashController from "./session_flash_controller"
application.register("session-flash", SessionFlashController)

import StaffPaymentController from "./staff_payment_controller"
application.register("staff-payment", StaffPaymentController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import StripeElementsController from "./stripe_elements_controller"
application.register("stripe-elements", StripeElementsController)

import StripeIdModalController from "./stripe_id_modal_controller"
application.register("stripe-id-modal", StripeIdModalController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import UtilsController from "./utils_controller"
application.register("utils", UtilsController)

import WeatherController from "./weather_controller"
application.register("weather", WeatherController)

import FeedbackFormController from "./feedback_form_controller"
application.register("feedback-form", FeedbackFormController)

import CheckoutTimerController from "./checkout_timer_controller"
application.register("checkout-timer", CheckoutTimerController)

import CalendarHighlightController from "./calendar_highlight_controller"
application.register("calendar-highlight", CalendarHighlightController)
